import { useAtom, useAtomValue } from "jotai";
import type { ReflectionResponse } from "../types";
import {
	generalFeelingAtom,
	dayDescriptionAtom,
	selectedReflectionsAtom,
	reflectionResponsesAtom,
	isFormValidAtom,
} from "../atoms/checkInFormAtoms";

interface UseCheckInFormReturn {
	generalFeeling: number;
	setGeneralFeeling: (value: number) => void;
	dayDescription: string;
	setDayDescription: (value: string) => void;
	selectedReflections: string | null;
	setSelectedReflections: (value: string | null) => void;
	reflectionResponses: Record<string, ReflectionResponse>;
	setReflectionResponses: (
		value:
			| Record<string, ReflectionResponse>
			| ((
					prev: Record<string, ReflectionResponse>,
			  ) => Record<string, ReflectionResponse>),
	) => void;
	isFormValid: boolean;
	resetForm: () => void;
}

export function useCheckInForm(): UseCheckInFormReturn {
	const [generalFeeling, setGeneralFeeling] = useAtom(generalFeelingAtom);
	const [dayDescription, setDayDescription] = useAtom(dayDescriptionAtom);
	const [selectedReflections, setSelectedReflections] = useAtom(
		selectedReflectionsAtom,
	);
	const [reflectionResponses, setReflectionResponses] = useAtom(
		reflectionResponsesAtom,
	);
	const isFormValid = useAtomValue(isFormValidAtom);
	const resetForm = () => {
		setGeneralFeeling(0);
		setDayDescription("");
		setSelectedReflections(null);
		setReflectionResponses({});
	};

	return {
		generalFeeling,
		setGeneralFeeling,
		dayDescription,
		setDayDescription,
		selectedReflections,
		setSelectedReflections,
		reflectionResponses,
		setReflectionResponses,
		isFormValid,
		resetForm,
	};
}
